module.exports = __webpack_public_path__ + "static/img/s-lingxin.fe002a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s-lingxin.png
// module id = K3R7
// module chunks = 1